import { render, staticRenderFns } from "./ModalPrivacy.vue?vue&type=template&id=209bc99e&"
import script from "./ModalPrivacy.vue?vue&type=script&lang=js&"
export * from "./ModalPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./ModalPrivacy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports